export default __webpack_public_path__ + "static/media/GOOGL.a7ceef53.png";